/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: plans/resource.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as pb_1 from "google-protobuf";
import * as grpc_1 from "@grpc/grpc-js";
import * as grpc_web_1 from "grpc-web";
export namespace plans.v1 {
    export class Resources extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            name?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            id?: string;
            name?: string;
        }): Resources {
            const message = new Resources({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                name?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.name.length)
                writer.writeString(3, this.name);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Resources {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Resources();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 3:
                        message.name = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Resources {
            return Resources.deserialize(bytes);
        }
    }
    export class CreateResourceRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            resourceId?: string;
            name?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("resourceId" in data && data.resourceId != undefined) {
                    this.resourceId = data.resourceId;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
            }
        }
        get resourceId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set resourceId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            resourceId?: string;
            name?: string;
        }): CreateResourceRequest {
            const message = new CreateResourceRequest({});
            if (data.resourceId != null) {
                message.resourceId = data.resourceId;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            return message;
        }
        toObject() {
            const data: {
                resourceId?: string;
                name?: string;
            } = {};
            if (this.resourceId != null) {
                data.resourceId = this.resourceId;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.resourceId.length)
                writer.writeString(1, this.resourceId);
            if (this.name.length)
                writer.writeString(2, this.name);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateResourceRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateResourceRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.resourceId = reader.readString();
                        break;
                    case 2:
                        message.name = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateResourceRequest {
            return CreateResourceRequest.deserialize(bytes);
        }
    }
    export class CreateResourceResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            resource?: Resources;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("resource" in data && data.resource != undefined) {
                    this.resource = data.resource;
                }
            }
        }
        get resource() {
            return pb_1.Message.getWrapperField(this, Resources, 1) as Resources;
        }
        set resource(value: Resources) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasResource() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            resource?: ReturnType<typeof Resources.prototype.toObject>;
        }): CreateResourceResponse {
            const message = new CreateResourceResponse({});
            if (data.resource != null) {
                message.resource = Resources.fromObject(data.resource);
            }
            return message;
        }
        toObject() {
            const data: {
                resource?: ReturnType<typeof Resources.prototype.toObject>;
            } = {};
            if (this.resource != null) {
                data.resource = this.resource.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasResource)
                writer.writeMessage(1, this.resource, () => this.resource.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateResourceResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateResourceResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.resource, () => message.resource = Resources.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateResourceResponse {
            return CreateResourceResponse.deserialize(bytes);
        }
    }
    export class GetResourceRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            resourceId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("resourceId" in data && data.resourceId != undefined) {
                    this.resourceId = data.resourceId;
                }
            }
        }
        get resourceId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set resourceId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            resourceId?: string;
        }): GetResourceRequest {
            const message = new GetResourceRequest({});
            if (data.resourceId != null) {
                message.resourceId = data.resourceId;
            }
            return message;
        }
        toObject() {
            const data: {
                resourceId?: string;
            } = {};
            if (this.resourceId != null) {
                data.resourceId = this.resourceId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.resourceId.length)
                writer.writeString(1, this.resourceId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetResourceRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetResourceRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.resourceId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetResourceRequest {
            return GetResourceRequest.deserialize(bytes);
        }
    }
    export class GetResourceResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            resource?: Resources;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("resource" in data && data.resource != undefined) {
                    this.resource = data.resource;
                }
            }
        }
        get resource() {
            return pb_1.Message.getWrapperField(this, Resources, 1) as Resources;
        }
        set resource(value: Resources) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasResource() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            resource?: ReturnType<typeof Resources.prototype.toObject>;
        }): GetResourceResponse {
            const message = new GetResourceResponse({});
            if (data.resource != null) {
                message.resource = Resources.fromObject(data.resource);
            }
            return message;
        }
        toObject() {
            const data: {
                resource?: ReturnType<typeof Resources.prototype.toObject>;
            } = {};
            if (this.resource != null) {
                data.resource = this.resource.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasResource)
                writer.writeMessage(1, this.resource, () => this.resource.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetResourceResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetResourceResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.resource, () => message.resource = Resources.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetResourceResponse {
            return GetResourceResponse.deserialize(bytes);
        }
    }
    export class ListResourcesRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            resourceId?: string[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("resourceId" in data && data.resourceId != undefined) {
                    this.resourceId = data.resourceId;
                }
            }
        }
        get resourceId() {
            return pb_1.Message.getFieldWithDefault(this, 1, []) as string[];
        }
        set resourceId(value: string[]) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            resourceId?: string[];
        }): ListResourcesRequest {
            const message = new ListResourcesRequest({});
            if (data.resourceId != null) {
                message.resourceId = data.resourceId;
            }
            return message;
        }
        toObject() {
            const data: {
                resourceId?: string[];
            } = {};
            if (this.resourceId != null) {
                data.resourceId = this.resourceId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.resourceId.length)
                writer.writeRepeatedString(1, this.resourceId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListResourcesRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListResourcesRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        pb_1.Message.addToRepeatedField(message, 1, reader.readString());
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListResourcesRequest {
            return ListResourcesRequest.deserialize(bytes);
        }
    }
    export class ListResourcesResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            resources?: Resources[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("resources" in data && data.resources != undefined) {
                    this.resources = data.resources;
                }
            }
        }
        get resources() {
            return pb_1.Message.getRepeatedWrapperField(this, Resources, 1) as Resources[];
        }
        set resources(value: Resources[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data: {
            resources?: ReturnType<typeof Resources.prototype.toObject>[];
        }): ListResourcesResponse {
            const message = new ListResourcesResponse({});
            if (data.resources != null) {
                message.resources = data.resources.map(item => Resources.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                resources?: ReturnType<typeof Resources.prototype.toObject>[];
            } = {};
            if (this.resources != null) {
                data.resources = this.resources.map((item: Resources) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.resources.length)
                writer.writeRepeatedMessage(1, this.resources, (item: Resources) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListResourcesResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListResourcesResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.resources, () => pb_1.Message.addToRepeatedWrapperField(message, 1, Resources.deserialize(reader), Resources));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListResourcesResponse {
            return ListResourcesResponse.deserialize(bytes);
        }
    }
    export abstract class UnimplementedResourcesServiceService {
        static definition = {
            CreateResource: {
                path: "/plans.v1.ResourcesService/CreateResource",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CreateResourceRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CreateResourceRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CreateResourceResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CreateResourceResponse.deserialize(new Uint8Array(bytes))
            },
            GetResource: {
                path: "/plans.v1.ResourcesService/GetResource",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetResourceRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetResourceRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetResourceResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetResourceResponse.deserialize(new Uint8Array(bytes))
            },
            ListResources: {
                path: "/plans.v1.ResourcesService/ListResources",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListResourcesRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListResourcesRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListResourcesResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListResourcesResponse.deserialize(new Uint8Array(bytes))
            }
        };
        [method: string]: grpc_1.UntypedHandleCall;
        abstract CreateResource(call: grpc_1.ServerUnaryCall<CreateResourceRequest, CreateResourceResponse>, callback: grpc_1.sendUnaryData<CreateResourceResponse>): void;
        abstract GetResource(call: grpc_1.ServerUnaryCall<GetResourceRequest, GetResourceResponse>, callback: grpc_1.sendUnaryData<GetResourceResponse>): void;
        abstract ListResources(call: grpc_1.ServerUnaryCall<ListResourcesRequest, ListResourcesResponse>, callback: grpc_1.sendUnaryData<ListResourcesResponse>): void;
    }
    export class ResourcesServiceClient {
        private _address: string;
        private _client: grpc_web_1.GrpcWebClientBase;
        constructor(address: string, credentials?: Object, options?: grpc_web_1.GrpcWebClientBaseOptions) {
            if (!options)
                options = {};
            options.format = options.format || "text";
            this._address = address;
            this._client = new grpc_web_1.GrpcWebClientBase(options);
        }
        private static CreateResource = new grpc_web_1.MethodDescriptor<CreateResourceRequest, CreateResourceResponse>("/plans.v1.ResourcesService/CreateResource", grpc_web_1.MethodType.UNARY, CreateResourceRequest, CreateResourceResponse, (message: CreateResourceRequest) => message.serialize(), CreateResourceResponse.deserialize);
        CreateResource(message: CreateResourceRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<CreateResourceRequest, CreateResourceResponse>(this._address + "/plans.v1.ResourcesService/CreateResource", message, metadata || {}, ResourcesServiceClient.CreateResource);
        }
        private static GetResource = new grpc_web_1.MethodDescriptor<GetResourceRequest, GetResourceResponse>("/plans.v1.ResourcesService/GetResource", grpc_web_1.MethodType.UNARY, GetResourceRequest, GetResourceResponse, (message: GetResourceRequest) => message.serialize(), GetResourceResponse.deserialize);
        GetResource(message: GetResourceRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetResourceRequest, GetResourceResponse>(this._address + "/plans.v1.ResourcesService/GetResource", message, metadata || {}, ResourcesServiceClient.GetResource);
        }
        private static ListResources = new grpc_web_1.MethodDescriptor<ListResourcesRequest, ListResourcesResponse>("/plans.v1.ResourcesService/ListResources", grpc_web_1.MethodType.UNARY, ListResourcesRequest, ListResourcesResponse, (message: ListResourcesRequest) => message.serialize(), ListResourcesResponse.deserialize);
        ListResources(message: ListResourcesRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListResourcesRequest, ListResourcesResponse>(this._address + "/plans.v1.ResourcesService/ListResources", message, metadata || {}, ResourcesServiceClient.ListResources);
        }
    }
}
